<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "VoiceAgentUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.voiceAgentUpdated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                agentName: this.$_.get(this.activity, 'payload.agentName'),
                agentId: this.$_.get(this.activity, 'payload.agentId')
            });
        }
    }
};
</script>

